import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-date-filter',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './date-filter.component.html',
})
export class DateFilterComponent {
  @Output() dateRangeSelected = new EventEmitter<{ start: Date | null; end: Date | null }>();

  startDate: string = '';
  endDate: string = '';

  emitRange() {
    const start = this.startDate ? new Date(this.startDate) : null;
    const end = this.endDate ? new Date(this.endDate) : null;
    this.dateRangeSelected.emit({ start, end });
  }
}

